import { useAtom } from "jotai";
import AddCohortModal from "./AddCohortModal";
import AddFolderModal from "./AddFolderModal";
import AddTeamModal from "./AddTeamModal";
import { SAdminBaseAtom } from "../../../stores/jotai/super-admin/superAdminBase";
import { DeleteGroupConfrimModal } from "./DeleteGroupConfrimModal";

type AddGroupModalProps = {
  parentGroupID: string;
};

export default function GroupModals({ parentGroupID=null }: AddGroupModalProps) {
  const [sAdminBase,setSAdminBase]=useAtom(SAdminBaseAtom);

  return (
    <>
      <AddCohortModal
        handleClose={() =>
          setSAdminBase((prev) => ({ ...prev, addCohortModalOpen: false }))
        }
        open={sAdminBase.addCohortModalOpen}
        parentGroupID={parentGroupID}
      />
      <AddTeamModal
        handleClose={() =>
          setSAdminBase((prev) => ({ ...prev, addTeamModalOpen: false }))
        }
        open={sAdminBase.addTeamModalOpen}
        parentGroupID={parentGroupID}
      />
      <AddFolderModal
        handleClose={() =>
          setSAdminBase((prev) => ({ ...prev, addFolderModalOpen: false }))
        }
        open={sAdminBase.addFolderModalOpen}
        parentGroupID={parentGroupID}
      />

      <DeleteGroupConfrimModal 
        open={sAdminBase.deleteGroupConfrimModalOpen}
        handleClose={()=>{
          setSAdminBase((prev) => ({ ...prev, deleteGroupConfrimModalOpen: false}))
        }}
      />
    </>
  );
}
